export { default } from "./ModalDelete";
export * from "./ModalDelete";
